export enum TranslationLanguageCode {
    EN = 'en',
    HU = 'hu',
}
